import React from "react"
import { css } from "styled-components"
import { Spacer } from "../../atoms/layout-primitives"
import { BlogGrid } from "../../atoms/layout-primitives/grid"
import VariantContainer from "../../atoms/variant-container"
import { getArticleFeatureFromType } from "../../molecules/article-feature"
import { IContentfulArticleFeature } from "../../types/blog.types"

interface IFeatureBlocksProps {
  features: IContentfulArticleFeature[]
}

/**
 * Displays 2 article features side by side
 * @param features - the article features
 */
const ArticleFeatureBlocks = ({ features }: IFeatureBlocksProps) => {
  return (
    <BlogGrid>
      <VariantContainer
        variants={[
          css`
            grid-column: 1/-1;
            display: grid;
            grid-template-columns: 1fr;

            gap: 24px;
          `,
          css`
            grid-template-columns: 1fr 1fr;
          `,
          css`
            gap: 32px;
          `,
        ]}
      >
        {features.map((feature) => {
          const Component = getArticleFeatureFromType(feature.featureType)
          return (
            <Component
              key={feature.heading}
              //@ts-ignore - icon will fallback to link if type incorrect
              icon={feature.icon.toLowerCase()}
              colour={feature.iconColour.hex}
              title={feature.heading}
              body={feature.copy}
              to={feature.pdf ? feature.pdf.file.url : feature.url}
              variants={[
                null,
                css`
                  flex-direction: column;
                  align-items: center;
                  text-align: center;
                `,
                css`
                  flex-direction: row;
                  align-items: flex-start;
                  text-align: left;
                `,
              ]}
            />
          )
        })}
      </VariantContainer>
      <Spacer height={{ sm: "48px", md: "64px" }} />
    </BlogGrid>
  )
}

export default ArticleFeatureBlocks
